import React, { useState, useRef, useEffect } from 'react';
import { Carousel, Tooltip, message, Input } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import wmail from '../../uploads/wmail.png';
import zup from '../../uploads/zup.jpg';
import docflow from '../../uploads/do.png';
import ithd from '../../uploads/ithd.png';
import sharepoint from '../../uploads/sharepoint.png';
import { LeftOutlined, RightOutlined, CloseOutlined } from '@ant-design/icons';
import { API_URL, API_username, API_password } from '../../utils/api';
// import { execFile } from 'child_process';

const DashboardContent = ({setLoading}) => {
  let sliderRef = useRef();
  const [slideIndex, setSlideIndex] = useState(1);

  const navigate = useNavigate();


  const next = () => {
    sliderRef.next();
    if(slideIndex < 5) setSlideIndex(slideIndex+1);
  };
  const previous = () => {
      sliderRef.prev();
      if(slideIndex > 1) setSlideIndex(slideIndex-1);
  };

  // const launchProgram = execFile('C:/Program Files/1cv8/8.3.23.1782/bin/1cv8.exe', [], (error, stdout, stderr) => {
  //   if (error) {
  //     throw error;
  //   }
  //   console.log(stdout);
  // });

  const launchProgram = () => {
    window.location.href = "file:///C:/Program Files/1cv8/8.3.23.1782/bin/1cv8.exe";
  }
  return <>    
    <div className='carousel-overlay' style={{ height: '10%' }}>
      <h1 className='center'>Полезные ссылки</h1>
      <button className='carousel-left-controller' onClick={previous}><LeftOutlined /></button>
      <button className='carousel-right-controller' onClick={next}><RightOutlined /></button>
    </div>
    <Carousel ref={slider => {sliderRef = slider;}} autoplay autoplaySpeed={8000}>
      <div className='dashboard-content-carousel-item'>
        <Tooltip placement="bottom" title="Корпоративная почта Enter Engineering" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <a target='_blank' href='https://wmail.ent-en.com/'><img src={wmail} alt='wmail' /></a>
        </Tooltip>
      </div>
      <div className='dashboard-content-carousel-item'>
        <Tooltip placement="bottom" title="1С:ЗУП КОРП" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <a target='_blank' href='https://web1c3.ent-en.com/hrmcorp'><img src={zup} alt='zup' /></a>
        </Tooltip>
      </div>
      <div className='dashboard-content-carousel-item'>
        <Tooltip placement="bottom" title="1С:Документооборот" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <a target='_blank' href=''><img src={docflow} alt='docflow' /></a>
        </Tooltip>
      </div>
      <div className='dashboard-content-carousel-item'>
        <Tooltip placement="bottom" title="ServiceDesk - Служба технической поддежки" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <a target='_blank' href='https://ithd.it'><img src={ithd} alt='ithd' /></a>
        </Tooltip>
      </div>
      <div className='dashboard-content-carousel-item'>
        <Tooltip placement="bottom" title="Сайт информационной системы 1С:ЗУП КОРП" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <a target='_blank' href='https://ecm.ent-en.com/sites/zupdevteam/SitePages/%D0%9F%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%BD%D0%B0%D1%8F-%D0%B1%D0%B8%D0%B1%D0%BB%D0%B8%D0%BE%D1%82%D0%B5%D0%BA%D0%B0(1).aspx'><img src={sharepoint} alt='sharepoint' /></a>
        </Tooltip>
      </div>
  </Carousel>
  </>;
};

export default DashboardContent;